import { z } from "zod";

export type Location = z.infer<typeof LocationSchema>;
export const LocationSchema = z.object({
  id: z.number(),
  location_group_id: z.number(),
  name_dict: z.string(),
  qr: z.string(),
  default_name: z.string(),
  is_default_location: z.boolean(),
  is_room_asking: z
    .boolean()
    .nullable()
    .transform((value) => value ?? false),
  name: z.string(),
});
